import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "gv_admin_token";

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

adminApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY);
            if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

export const AuthApi = {
    login: (password) => adminApi.post("/admin/login", { password }),
    me: () => adminApi.get("/admin/me"),
    logout: () => {
        localStorage.removeItem(TOKEN_KEY);
    },
    saveToken: (t) => localStorage.setItem(TOKEN_KEY, t),
    hasToken: () => !!localStorage.getItem(TOKEN_KEY),
};

export const AdminMessagesApi = {
    list: (params = {}) => adminApi.get("/admin/messages", { params }),
    updateStatus: (id, status) =>
        adminApi.patch(`/admin/messages/${id}`, { status }),
    stats: () => adminApi.get("/admin/stats"),
};
